export default [
  {
    path: '/external',
    name: 'claim-application',
    component: resolve => require(['views/claim-application'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/batch-monitoring',
    name: 'batch-monitoring',
    component: resolve => require(['views/batch-monitoring'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/export-history-batch',
    name: 'export-history-batch',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '跑批监测/异常日志导出' }
  }
]
